import React from 'react';

import {
  SubmissionConfidenceContext,
  type ProviderState,
} from '../_state/confidence.state.context';

export function useSubmissionConfidence() {
  const context = React.useContext<ProviderState>(SubmissionConfidenceContext);

  if (!context) {
    throw new Error(
      'useSubmissionConfidence must be used within an SubmissionConfidenceProvider'
    );
  }

  return context;
}
